export default __webpack_public_path__ + "static/media/cache.73593021.png";